import {useAuthContext} from '@oslokommune/auth-bff/react'
import React, {useEffect, useRef} from "react";
import {PktButton, PktModal} from "@oslokommune/punkt-react";

export const ExpiredSessionModal = () => {
  const authContext = useAuthContext()
  const dialogRef = useRef<HTMLDialogElement>(null)

  useEffect(() => {
    if (authContext.state === 'expired') {
      dialogRef.current?.showModal()
    }
  }, [authContext.state])

  return (
    <PktModal ref={dialogRef} headingText={"Sesjonen din har utløpt"}>
      Du må logge inn på nytt for å fortsette.
      <PktButton className={'mt-size-16'} onClick={() => authContext.login()}>
        Logg inn på nytt
      </PktButton>
    </PktModal>
  )
}
